<a href="javascript:void(0)" (click)="showExploreOtherApps()" class="d-block p-3"></a>
<div *ngIf="IsExploreOtherAppsVisibled" class="position-relative d-inline-block">
  <div id="app-menu-container" class="app-menu-container row">
    <div class="col-12 app-menu-title d-flex flex-row align-items-center justify-content-center p-0">
      <a id="app-menu-title" [href]="MedPointAppsEndPoint">
        <img src="{{cdnEndPoint}}/medpointapps/img/MedPoint Apps.svg">
      </a>
      <div id="close-menu" class="icon-close d-flex flex-grow-1 justify-content-end m-0 pe-4  k-cursor-pointer" (click)="hideExploreOtherApps()"></div>
    </div>
    <div class="col-12">
      <div class="my-3" style="line-height: 20px;">
        <h2 class="m-0">My active apps</h2>
      </div>
      <div id="app-menu-div" class="row" *ngIf="myAccessibleApps.length > 0; else noData">
        <div *ngFor="let apps of myAccessibleApps; let $first=first; let $last=last" id="sidemenu-{{apps.MedPointPlatformName}}" [ngClass]="{'app-menu-first': $first, 'margin-left-zero': $last}" class="col-5 ms-2 me-2 mb-3 app-items">
          <a href="https://{{apps.href}}{{envPath}}" class="d-flex align-items-center justify-content-center h-100">
            <img src="{{cdnEndPoint}}{{apps.image}}" alt="{{apps.MedPointPlatformName}}" />
          </a>
        </div>
      </div>
      <ng-template #noData>
        <div class="row">
          <div class="col-12 text-center" *ngIf="!IsAppsLoading">No active apps</div>
          <div class="col-12 text-center" *ngIf="IsAppsLoading"><span class="sm-loading"></span></div>
        </div>
      </ng-template>
    </div>
    <div class="col-12">
      <div class="my-3" style="line-height: 20px; ">
        <h2 class="m-0">Available apps</h2>
      </div>
      <div id="app-menu-explore-div" class="explore-apps" *ngIf="otherExploreApps.length > 0; else noExploreData">
        <div class="row">
          <!--#=data[i].Name.split(" ").join(" ").toLowerCase()-->
          <div *ngFor="let apps of otherExploreApps;" id="explore-app-{{apps.Name}}" class="col-lg-12 explore-items" (click)="SendUserInterestedApp(apps)">
            <div class="explore-img"><img src="{{cdnEndPoint}}{{apps.SmallImage}}" /></div>
            <div class="explore-title">
              <div class="explore-text" title="{{apps.Name}}">{{apps.Name}}</div>
              <div class="explore-desc" title="{{apps.Description}}">{{apps.Description}}</div>
            </div>
            <div class="explore-arrow">
              <img src="{{cdnEndPoint}}/triport/icons/leftmenu/arrow.svg" alt=">" />
            </div>
          </div>
        </div>
      </div>
      <ng-template #noExploreData>
        <div class="row">
          <div class="col-12 text-center" *ngIf="!IsAppsLoading">No other MedPoint apps</div>
          <div class="col-12 text-center" *ngIf="IsAppsLoading"><span class="sm-loading"></span></div>
        </div>
      </ng-template>
    </div>
  </div>
  <div style="display: block; position: fixed; height: 100%; width: 100%; background: #fff; background: rgba(255,255,255,.5); top: 0; left: 0; z-index: 1;" (click)="hideExploreOtherApps()"></div>
</div>

